import React from "react";
import styled from "styled-components";

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

export default function LessonHideSelectBox(props) {
  const { isHide, setIsHide } = props;
  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <Button isClicked={!isHide} onClick={() => setIsHide(false)}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={!isHide ? theme.background : theme.text} cursor='pointer'>{t('system.public')}</Text>
      </Button>
      <Button isClicked={isHide} onClick={() => setIsHide(true)}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={isHide ? theme.background : theme.text} cursor='pointer'>{t('system.private')}</Text>
      </Button>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  gap: 5px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 8px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
